import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";
import { useUserInfor } from "../../../../../Context/User";
import { NavLink } from "react-router-dom";
import { faIndustry } from "@fortawesome/free-solid-svg-icons";

export default function SubNavRelatoriosBI() {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {mostrarNavDeTela(
                ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.ID_TELA,
                UserInfor.TELAS
            ) && (
                <>
                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_LEADS.DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">Dashboard Leads</span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VISITA
                                    .DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">Dashboard Visita</span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS
                                    .RELATORIOS_BI_ANALISE_CREDITO.DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">
                                Dashboard Análise Crédito
                            </span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VENDAS
                                    .DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">Dashboard Vendas</span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ESTOQUE
                                    .DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">Dashboard Estoque</span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_PERDAS
                                    .DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">Dashboard Perdas</span>
                        </NavLink>
                    </li>

                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_MARKETING
                                    .DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">
                                Dashboard Marketing
                            </span>
                        </NavLink>
                    </li>

                    {/* <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.VENDAS.TELAS
                                    .RELATORIOS_BI_GESTAO_ATENDIMENTO.DS_PATH
                            }
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faIndustry} />
                            </span>
                            <span className="menu-text">
                                Dashboard Gestão Atendimento
                            </span>
                        </NavLink>
                    </li> */}
                </>
            )}
        </>
    );
}
